import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({
    name: 'translate',
    pure: false,
})
export class TranslatePipe implements PipeTransform {
  private _translate = inject(TranslationService);


  transform(value: any, args?: any, defaultValue?: string | any): any {
    const translateKey = /^[a-z0-9_.-]+$/i.test(value) && value?.includes('.');
    if (translateKey) {
      return this._translate.translate(value, args, defaultValue);
    } else {
      return value;
    }
  }

}
